import { createClient } from '@supabase/supabase-js';

declare global { 
  interface Window { 
    __sp_client?: ReturnType<typeof createClient> 
  } 
}

export const supabase = (() => {
  if (typeof window !== 'undefined' && window.__sp_client) return window.__sp_client;

  const c = createClient(
    import.meta.env.VITE_SUPABASE_URL!,
    import.meta.env.VITE_SUPABASE_ANON_KEY!,
    {
      auth: {
        flowType: 'pkce',
        detectSessionInUrl: true,    // let Supabase handle the exchange automatically
        persistSession: true,
        autoRefreshToken: true,
        storageKey: 'nomera-auth',
      },
    }
  );

  // Only log in development
  if (import.meta.env.DEV) {
    // @ts-ignore
    c.__id = Math.random().toString(36).slice(2);
    console.log('[supabase] PKCE client id =', /* @ts-ignore */ c.__id);
  }

  if (typeof window !== 'undefined') window.__sp_client = c;
  return c;
})();

// Legacy function for backward compatibility
export function getSupabase() {
  return supabase;
}